/// <reference types="@types/googlemaps" />
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { ViewChild } from '@angular/core';
import {
  MapLocations,
  MgLocation,
  MapMarkerGroup2Show,
  ObjMarkerGroup,
  MapMarkerGroup,
  OBJ_MAX_GRP_DISTANCE_BTW_COORD,
} from '../../../models/location.model';
import { MapService } from '../../../services/map.service';
import { LocationFinderService } from '../../../services/location-finder.service';
import { GeolocationService } from '../../../services/geolocation.service';
import { takeUntil } from 'rxjs/operators';
import { selectQueryParams } from 'src/app/store/query-params';
import { Store } from '@ngrx/store';
import {
  fromEventPattern,
  Observable,
  combineLatest,
  Subscription,
  take,
} from 'rxjs';
import { BaseComponent } from '../../../shared/base.component';
import { UtilsService } from '../../../services/utils.service';
import { EnvService } from '../../../services/env.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { SdfCardLabels } from '../../../app.models';
import { Who } from '../../../models/location.model';

@Component({
    selector: 'app-location-map',
    templateUrl: './location-map.component.html',
    styleUrls: ['./location-map.component.scss'],
    standalone: false
})
export class LocationMapComponent
  extends BaseComponent
  implements OnInit, OnDestroy, OnChanges
{
  @Output() basicSearchEvent: EventEmitter<void> = new EventEmitter();
  @Input() pinLocation?: boolean;
  @Input() google: any;
  @Input() flow: string;
  @Input() originalAddressSearched: string;
  @Input() labels: SdfCardLabels;
  private endpoint: string;

  @ViewChild('gmap', { static: true }) gmapElement: any;
  map!: google.maps.Map;
  marker!: google.maps.Marker;
  bounds!: google.maps.LatLngBounds;
  markers: any[] = [];
  selLocLat: any;
  selLocLong: any;
  geocoder!: google.maps.Geocoder;
  address: any;
  showSearchButton: boolean = false;
  boundsChanged!: Observable<any>;
  zoomChanged!: Observable<any>;
  dragEnd!: Observable<any>;
  someservice: any;
  isMobileSize: boolean = false;
  ismobile$: Observable<boolean>;
  mapMarkerGroup2Show: MapMarkerGroup2Show;
  sdfCardLabels: SdfCardLabels;

  public hideMap: boolean = false;
  private hideMapSubscription: Subscription;

  constructor(
    public locationFinderService: LocationFinderService,
    public mapService: MapService,
    public geolocationService: GeolocationService,
    private store: Store<any>,
    public utilService: UtilsService,
    private envService: EnvService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    super();
    this.ismobile$ = this.utilService.isMobile;
    this.ismobile$.subscribe((isMobile: any) => { // Todo: Tim: Fix types
      this.isMobileSize = isMobile;
      if (this.map) {
        this.map.setOptions({ disableDefaultUI: this.isMobileSize });
      }
    });
    this.matIconRegistry.addSvgIcon(
      'ico-arrow',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../../../assets/images/map-location/tag-arrow.svg'
      )
    );

    this.hideMapSubscription = this.locationFinderService.hide$.subscribe(
      ({ who, value }: any) => { // Todo: Tim: Fix types
        if (who === Who.map) this.hideMap = value;
      }
    );
  }

  public ngOnInit() {
    this.store.select(selectQueryParams).subscribe((queryParamsData: any) => { // Todo: Tim: Fix types
      this.endpoint = queryParamsData.endpoint || 'v2';
    });
  }

  ngOnChanges() {
    if (this.google) {
      const { searchCompleted, branchSelected } = this.locationFinderService;
      this.initializeMap();
      this.showDefaultCountry();

      if (!!!this.locationFinderService.getDefaultAddress()) {
        this.getDeviceLocation();
      }
      combineLatest([searchCompleted, branchSelected])
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => {
          this.renderMap();
        });

      if (this.map) {
        this.zoomChanged.subscribe(() => {
          if (this.isMobileSize) {
            this.calcGroupList2Show();
          }
        });
      }
    }
  }

  calcGroupList2Show() {
    // console.log("%c changed zoom", "color:purple", {locations:this.locationFinderService.mapLocations, zoomValue:this.map.getZoom()})
    this.clearMarkers();
    const markers = this.createResultsMarkers(
      this.locationFinderService.mapLocations
    );
    markers.forEach((marker) => {
      marker.setMap(this.map);
      this.markers.push(marker);
    });
  }

  renderMap() {
    this.clearMarkers();
    if (
      this.locationFinderService.isShowDetail ||
      (this.locationFinderService.selectedBranch && this.pinLocation)
    ) {
      this.showDetailsMap();
    } else {
      this.showResultsMap();
    }
  }

  geoCodeCoords(pos: any) {
    this.mapService
      .geoCodePosition(pos, this.google)
      .pipe(takeUntil(this.destroy$))
      .subscribe((geocodedAddress: any) => { // Todo: Tim: Fix types
        if (!!geocodedAddress) {
          this.locationFinderService.setDefaultAddress(geocodedAddress);
          this.locationFinderService
            .searchLocationApi(this.flow, this.endpoint)
            .subscribe((data: any) => {}); // Todo: Tim: Fix types
        }
      });
  }

  getDeviceLocation() {
    this.geolocationService.getCurrentPosition().subscribe((position: any) => { // Todo: Tim: Fix types
      if (!!position.coords) {
        const pos = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        this.geoCodeCoords(pos);
      }
    });
  }

  runSearchInArea() {
    this.geoCodeCoords(this.address);
  }

  showDetailsMap() {
    const selectedBranch = this.locationFinderService.selectedBranch;

    const pos = new this.google.maps.LatLng(
      selectedBranch.locationDetails!.latitude,
      selectedBranch.locationDetails!.longitude
    );

    const marker = new this.google.maps.Marker({
      position: pos,
      map: this.map,
      title: selectedBranch.locationDetails!.name,
      icon: {
        path: 'M40,0C26.191,0,15,11.194,15,25c0,23.87,25,55,25,55s25-31.13,25-55C65,11.194,53.807,0,40,0z     M40,38.8c-7.457,0-13.5-6.044-13.5-13.5S32.543,11.8,40,11.8c7.455,0,13.5,6.044,13.5,13.5S47.455,38.8,40,38.8z',
        scale: 0.5,
        fillColor: '#ff0000',
        fillOpacity: 1,
        strokeColor: '#ffffff',
        strokeOpacity: 1,
        strokeWeight: 0,
        anchor: new this.google.maps.Point(0, 0),
      },
    });

    this.map.setZoom(18);
    this.map.setCenter(marker.getPosition());
    this.markers.push(marker);
  }

  createResultsMarkers(locations: any[]) {
    //  console.log("%c /----createResultMakers-----\\","background:red")// TODO: remove consoles on future versions
    if (this.isMobileSize) {
      this.populateGroupMarker(locations);
    }
    //  console.log("%c mapMarkerGroup2show", "background:blue;color:white", this.mapMarkerGroup2Show)
    //  console.log("%c \\------createResultMakers------/", "background:red")// TODO: remove consoles on future versions

    let arrIdInserted: string[] = [];
    const markerListGot = locations.map((location: MapLocations, i: number) => {
      if (
        !Array.isArray(this.mapMarkerGroup2Show?.locationIds) ||
        !this.mapMarkerGroup2Show.locationIds.includes(location.locationId)
      ) {
        const number = this.isMobileSize ? ' ' : String(i + 1);
        const label = {
          text: number,
          color: 'white',
          font: 'Roboto',
          fontSize: '12px',
        };
        const icon = {
          url: 'assets/images/map-location/tag-red-bubble.svg',
          scale: 22,
          fillColor: '#ff0000',
          fillOpacity: 1,
          strokeColor: '#ffffff',
          strokeOpacity: 1,
          strokeWeight: 0,
        };
        const fncClickMarker = () =>
          this.openLocationDetails(location.locationId);
        if (location.latitude && location.longitude) {
          return this.createMarker(
            {
              latitude: parseFloat(location.latitude),
              longitude: parseFloat(location.longitude),
              name: location.name,
              icon,
              label,
            },
            fncClickMarker
          );
        }
      } else {
        const locMarker =
          this.mapMarkerGroup2Show.mapMarkerGroup[
            this.mapMarkerGroup2Show.locId2markerGroupId[location.locationId]
          ];
        if (!arrIdInserted.includes(locMarker.name)) {
          arrIdInserted.push(locMarker.name);
          return this.createMarker(
            {
              latitude: parseFloat(locMarker.latitude),
              longitude: parseFloat(locMarker.longitude),
              name: locMarker.name,
              icon: locMarker.icon,
              label: locMarker.label,
            },
            () => {}
          ); //TODO: create function action click to zoom
        }
      }
    });

    return markerListGot.filter((marker) => typeof marker !== 'undefined');
  }

  createMarker(
    objParams: {
      latitude: number;
      longitude: number;
      name: string | undefined;
      icon: object;
      label: { text: string } | undefined;
    },
    fncClickMarker: VoidFunction
  ) {
    const pos = new this.google.maps.LatLng(
      objParams.latitude,
      objParams.longitude
    );
    const objMarker: any = { // Todo: Tim: Fix types
      position: pos,
      map: this.map,
      title: objParams.name,
      icon: objParams.icon,
    };
    if (objParams.label && typeof objParams.label?.text !== 'undefined') {
      objMarker['label'] = objParams.label;
    }
    const marker = new this.google.maps.Marker(objMarker);
    marker.addListener('click', () => fncClickMarker());

    return marker;
  }

  createMarkerCurrentPosition() {
    if (navigator.geolocation) {
      const icon = {
        url: 'assets/images/map-location/tag-act-pos.svg',
        scale: 20,
        fillColor: '#ff0000',
        fillOpacity: 1,
        strokeColor: '#ffffff',
        strokeOpacity: 1,
        strokeWeight: 0,
      };
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const latitude = position.coords.latitude;
          const longitude = position.coords.longitude;
          // console.log("current location","color:green", {longitude, latitude})
          if (latitude && longitude) {
            return this.createMarker(
              {
                latitude: latitude,
                longitude: longitude,
                name: '',
                icon,
                label: undefined,
              },
              () => {}
            );
          }
        },
        (error) => {
          // console.error('Error current location', error);
          if (!['prod', 'ext'].includes(this.envService.getCmsEnv())) {
            const lat: number = 39.1361;
            const long: number = -84.4831;
            if (lat && long) {
              // console.log(`%c env ${this.envService.getCmsEnv()} Mock Current Location`, "color:red", {lat, long, placeSearch:"cin*"});
              return this.createMarker(
                {
                  latitude: lat,
                  longitude: long,
                  name: '',
                  icon,
                  label: undefined,
                },
                () => {}
              );
            }
          }
        }
      );
    } else {
      console.warn('Geolocation is not available on this browser');
    }
  }

  populateGroupMarker(locations: MapLocations[]) {
    //  console.log("%c locations","background:pink;color:red", locations)
    let idGroup = 0;
    let mapMarkerGroup2Show: MapMarkerGroup2Show = {
      locationIds: [],
      locId2markerGroupId: {},
      mapMarkerGroup: {},
    };

    for (let iLoc1 in locations) {
      const loc1 = { ...locations[iLoc1] };
      for (let iLoc2 in locations) {
        const loc2 = { ...locations[iLoc2] };
        if (
          typeof loc2.latitude !== 'undefined' &&
          typeof loc2.longitude !== 'undefined' &&
          typeof loc1.latitude !== 'undefined' &&
          typeof loc1.longitude !== 'undefined' &&
          parseInt(iLoc1) < parseInt(iLoc2)
        ) {
          const { latAvg, longAvg, distance } = this.distanceByCoordinates(
            parseFloat(loc1.latitude),
            parseFloat(loc2.latitude),
            parseFloat(loc1.longitude),
            parseFloat(loc2.longitude)
          );
          //console.log(`%c iter-${iLoc1}.${iLoc2} distance/zoom`, "background:pink", { distance, zoom: this.map.getZoom(),zoomDMax: OBJ_MAX_GRP_DISTANCE_BTW_COORD[this.map.getZoom()], loc1, loc2 })
          if (distance <= OBJ_MAX_GRP_DISTANCE_BTW_COORD[this.map.getZoom() as keyof typeof OBJ_MAX_GRP_DISTANCE_BTW_COORD]) { // Todo: #refactor - there may be a better way to implement this
            if (
              !mapMarkerGroup2Show.locationIds.includes(loc1.locationId) &&
              !mapMarkerGroup2Show.locationIds.includes(loc2.locationId)
            ) {
              mapMarkerGroup2Show.locationIds.push(
                ...[loc1.locationId, loc2.locationId]
              );
              const markerGroup: ObjMarkerGroup = {
                locationsId: [loc1.locationId, loc2.locationId],
                name: `G${idGroup}`,
                latitude: latAvg,
                longitude: longAvg,
                label: {
                  text: '2', // TODO: second lap to compact more the coordinates
                  color: 'white',
                  font: 'Roboto',
                  fontSize: '12px',
                },
                icon: {
                  path: this.google.maps.SymbolPath.CIRCLE,
                  scale: 15,
                  fillColor: '#ff0000',
                  fillOpacity: 1,
                  strokeColor: '#ffffff',
                  strokeOpacity: 1,
                  strokeWeight: 0,
                },
              };
              mapMarkerGroup2Show.locId2markerGroupId = {
                ...mapMarkerGroup2Show.locId2markerGroupId,
                [loc1.locationId]: `G${idGroup}`,
                [loc2.locationId]: `G${idGroup}`,
              };
              mapMarkerGroup2Show.mapMarkerGroup = {
                ...mapMarkerGroup2Show.mapMarkerGroup,
                [`G${idGroup}`]: markerGroup,
              };

              mapMarkerGroup2Show = this.addMoreLoc2GroupMarker(
                locations,
                { ...mapMarkerGroup2Show },
                markerGroup,
                2
              );
              // console.log("%c mapMarkerGroup2Show final row", "background:orange; color:red", JSON.parse(JSON.stringify(mapMarkerGroup2Show)))
              idGroup++;
            }
          }
        }
      }
    }
    this.mapMarkerGroup2Show = { ...mapMarkerGroup2Show };
  }
  addMoreLoc2GroupMarker(
    locations: MapLocations[],
    mapMarkerGroup2Show: MapMarkerGroup2Show,
    objMarkerGroup: ObjMarkerGroup,
    count: number
  ) {
    // console.log(`%c -${count}-addMoreLoc: watching objMarkerGroup`, "background:orange", JSON.parse(JSON.stringify(mapMarkerGroup2Show)))
    const locationIds: string[] = [...mapMarkerGroup2Show.locationIds];
    const locId2markerGroupId: { [locationId: string]: string } = {
      ...mapMarkerGroup2Show.locId2markerGroupId,
    };

    let newMapMarkerGroup2Show: MapMarkerGroup2Show = mapMarkerGroup2Show;
    locations.forEach((location: MapLocations) => {
      if (
        !locationIds.includes(location.locationId) &&
        location.latitude &&
        location.longitude
      ) {
        const { latAvg, longAvg, distance } = this.distanceByCoordinates(
          parseFloat(location.latitude),
          parseFloat(objMarkerGroup.latitude),
          parseFloat(location.longitude),
          parseFloat(objMarkerGroup.longitude)
        );
        if (distance <= OBJ_MAX_GRP_DISTANCE_BTW_COORD[this.map.getZoom() as keyof typeof OBJ_MAX_GRP_DISTANCE_BTW_COORD]) { // Todo: #refactor - there may be a better way to implement this
          // console.log("%c locs to add", "background:yellow", { Id1: location.locationId, Id2: objMarkerGroup.name, locationIds:[...locationIds] })
          count++;
          objMarkerGroup.latitude = latAvg.toString();
          objMarkerGroup.longitude = longAvg.toString();
          objMarkerGroup.label.text = String(count);
          objMarkerGroup.locationsId.push(location.locationId);
          locationIds.push(location.locationId);
          // console.log("%c locationsIds pushed", "background: yellow; color:red", [...locationIds])
          locId2markerGroupId[location.locationId] = objMarkerGroup.name;
          mapMarkerGroup2Show.mapMarkerGroup[objMarkerGroup.name] = {
            ...objMarkerGroup,
          };

          newMapMarkerGroup2Show = {
            locationIds: [...locationIds],
            locId2markerGroupId,
            mapMarkerGroup: { ...mapMarkerGroup2Show.mapMarkerGroup },
          };
          const possibleNewMapMarkerGroup2Show = this.addMoreLoc2GroupMarker(
            locations,
            newMapMarkerGroup2Show,
            { ...objMarkerGroup },
            count
          );
          if (
            parseInt(
              possibleNewMapMarkerGroup2Show.mapMarkerGroup[objMarkerGroup.name]
                .label.text
            ) > count
          ) {
            newMapMarkerGroup2Show = { ...possibleNewMapMarkerGroup2Show };
          }
        }
      }
    });
    return newMapMarkerGroup2Show;
  }

  distanceByCoordinates(
    lat1: number,
    lat2: number,
    long1: number,
    long2: number
  ): { latAvg: string; longAvg: string; distance: number } {
    const R = 6371; // Earth Rad Km
    const dLat = lat2 - lat1;
    const dLon = long2 - long1;

    const deg2rad = (deg: number) => deg * (Math.PI / 180);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) *
        Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = parseFloat((R * c).toFixed(4));

    const latAvg = lat1 + (lat2 - lat1) * (distance / 2 / distance);
    const longAvg = long1 + (long2 - long1) * (distance / 2 / distance);

    return { latAvg: latAvg.toString(), longAvg: longAvg.toString(), distance };
  }

  showOtherListLocations(originalAddress?: string) {
    const center = this.map.getCenter();
    if (typeof originalAddress === 'undefined') {
      this.callLocationFinderService({
        address: '',
        latitude: center.lat(),
        longitude: center.lng(),
      });
    } else {
      this.callLocationFinderService({
        address: originalAddress,
        latitude: '',
        longitude: '',
      });
    }
  }

  callLocationFinderService(otherPos: {
    address?: string;
    latitude?: number | '';
    longitude?: number | '';
  }) {
    this.locationFinderService.updateViewMoreSearch(false);
    this.basicSearchEvent.emit();
    this.locationFinderService.updateSearchQuery(otherPos);
    this.locationFinderService
      .searchLocationApi(this.flow)
      .subscribe((data: any) => { // Todo: Tim: Fix types
        this.locationFinderService.searchCompleted.next(true);
      });
  }

  createEventHandler(listener: any) {
    return (handler: any) => {
      this.map.addListener(listener, handler);
    };
  }

  removeEventHandler() {
    return (handler: any, listener: any) =>
      this.google.maps.event.removeListener(listener);
  }

  enableSearchableArea() {
    this.boundsChanged = fromEventPattern(
      this.createEventHandler('bounds_changed'),
      this.removeEventHandler()
    );

    this.boundsChanged.subscribe(() => {
      if (this.map.getCenter()) {
        const address = {
          lat: this.map.getCenter().lat(),
          lng: this.map.getCenter().lng(),
        };
        this.address = address;
      }
    });

    this.zoomChanged = fromEventPattern(
      this.createEventHandler('zoom_changed'),
      this.removeEventHandler()
    );

    this.dragEnd = fromEventPattern(
      this.createEventHandler('dragend'),
      this.removeEventHandler()
    );

    combineLatest([this.zoomChanged, this.dragEnd])
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.showSearchButton = true;
      });
  }

  showResultsMap() {
    this.bounds = new this.google.maps.LatLngBounds(null);
    this.markers = this.createResultsMarkers(
      this.locationFinderService.mapLocations
    );
    if (this.markers.length) {
      this.markers.forEach(
        (marker) => this.bounds.extend(marker.getPosition()),
        this
      );
      if (this.bounds) {
        this.map.fitBounds(this.bounds);
        this.map.panToBounds(this.bounds);
      }
    }
    this.showSearchButton = false;
    this.enableSearchableArea();
  }

  openLocationDetails(locId: string) {
    const loc: MgLocation =
      this.locationFinderService.searchResults.locations.find(
        (item: { locationDetails: { locationId: string } }) =>
          item.locationDetails.locationId === locId
      );
    this.locationFinderService.updateSelectedBranch(loc);
    this.locationFinderService.toggleBranchDetails(true);
    this.locationFinderService.branchSelected.next(true);
  }

  initializeMap() {
    const mapProp = {
      zoom: 12,
      mapTypeId: this.google.maps.MapTypeId.ROADMAP,
      fullscreenControl: false,
      streetViewControl: false,
      mapTypeControl: false,
      gestureHandling: 'cooperative',
      disableDefaultUI: this.isMobileSize,
    };
    this.geocoder = new this.google.maps.Geocoder();
    this.map = new this.google.maps.Map(
      this.gmapElement.nativeElement,
      mapProp
    );
    this.createMarkerCurrentPosition();
  }

  showDefaultCountry() {
    if (
      this.locationFinderService.selectedCountry &&
      !this.locationFinderService.selectedBranch
    ) {
      const componentRestrictions = {
        country: this.locationFinderService.selectedCountry.iso2Code,
        ...(this.locationFinderService.selectedCountry.iso2Code === 'IE' && {
          locality: 'Dublin',
        }),
      };
      this.geocoder?.geocode(
        { componentRestrictions },
        (results, status: any) => {
          if (status === 'OK') {
            this.map.setCenter(results[0].geometry.location);
            this.map.setZoom(8);
          }
        }
      );
    }
  }

  setMapOnAll(map: null) {
    this.markers.forEach((marker) => marker.setMap(map));
  }

  clearMarkers() {
    this.setMapOnAll(null);
  }

  public ngOnDestroy(): void {
    this.hideMapSubscription.unsubscribe();
  }
}
